import React from "react";
import { defaultExcelInvoice } from "../data/excelInvoiceConfig";

const ExcelTemplate = ({ data = {} }) => {

  const invoice = {
  company: { ...defaultExcelInvoice.company, ...(data.company || {}) },
  invoice: { ...defaultExcelInvoice.invoice, ...(data.invoice || {}) },
  client: { ...defaultExcelInvoice.client, ...(data.client || {}) },
  shipTo: { ...defaultExcelInvoice.shipTo, ...(data.shipTo || {}) },
 items: defaultExcelInvoice.items,
  summary: { ...defaultExcelInvoice.summary, ...(data.summary || {}) }
};


  const excelBlue = "bg-[#003399]";
  const excelLightBlue = "bg-[#B9D1FF]";

  const calculatedItems = invoice.items.map((item) => {
    const qty = Number(item.qty || 0);
    const rate = Number(item.rate || 0);
    return { ...item, amount: (qty * rate).toFixed(2) };
  });

  const subtotal = calculatedItems.reduce((s, i) => s + Number(i.amount || 0), 0).toFixed(2);
  const taxAmount = ((subtotal * Number(invoice.summary.taxRate || 0)) / 100).toFixed(2);
  const total = (Number(subtotal) + Number(taxAmount)).toFixed(2);

  return (
    <div id="excel-invoice" className="bg-white p-4 text-gray-800 mx-auto text-[10px] leading-tight">

      <div className="flex justify-between items-start mb-2">
        <div>
          <h1 className="text-sm font-bold">{invoice.company.name}</h1>
          <p className="text-[9px] text-gray-500 max-w-[260px]">
            {invoice.company.address}<br />
            GSTIN: {invoice.company.gstin}<br />
            {invoice.company.phone} | {invoice.company.email}
          </p>
        </div>
        <h2 className="text-2xl font-light text-[#003399] tracking-widest uppercase">Invoice</h2>
      </div>

      <div className="grid grid-cols-2 border border-gray-400 mb-2">
        <div className="border-r border-gray-400 p-1 space-y-[2px]">
          <div className="flex justify-between"><span>Invoice#</span><span className="font-bold">{invoice.invoice.number}</span></div>
          <div className="flex justify-between"><span>Date</span><span>{invoice.invoice.date}</span></div>
          <div className="flex justify-between"><span>Terms</span><span>{invoice.invoice.terms}</span></div>
          <div className="flex justify-between"><span>Due</span><span>{invoice.invoice.dueDate}</span></div>
        </div>
        <div className="p-1 text-[9px] text-gray-500">
          {invoice.company.name}<br />
          {invoice.company.phone}<br />
          {invoice.company.email}
        </div>
      </div>

      <div className="grid grid-cols-2 border border-gray-400 bg-gray-100 font-bold uppercase text-[9px]">
        <div className="border-r border-gray-400 p-1 px-2">Bill To</div>
        <div className="p-1 px-2">Ship To</div>
      </div>

      <div className="grid grid-cols-2 border-x border-b border-gray-400 mb-2">
        <div className="border-r border-gray-400 p-2">
          <p className="font-bold">{invoice.client.name}</p>
          <p className="text-gray-500">{invoice.client.address}</p>
        </div>
        <div className="p-2">
          <p className="font-bold">{invoice.shipTo.name || "Delivery Address"}</p>
          <p className="text-gray-500">{invoice.shipTo.address || "Same as billing address"}</p>
        </div>
      </div>

      <table className="w-full border-collapse border border-gray-400 mb-2">
        <thead>
          <tr className={`${excelBlue} text-white font-bold`}>
            <th className="border border-white/20 p-1 w-8 text-center">#</th>
            <th className="border border-white/20 p-1 text-left">Item & Description</th>
            <th className="border border-white/20 p-1 w-14 text-center">Qty</th>
            <th className="border border-white/20 p-1 w-20 text-center">Rate (₹)</th>
            <th className="border border-white/20 p-1 w-20 text-center">Amount (₹)</th>
          </tr>
        </thead>
        <tbody>
          {calculatedItems.map((item, idx) => (
            <tr key={idx}>
              <td className="border border-gray-400 p-1 text-center align-top">{idx + 1}</td>
              <td className="border border-gray-400 p-1 align-top">
                <p className="font-bold">{item.desc || "Item"}</p>
                <p className="text-[9px] text-gray-500">{item.subDesc || ""}</p>
              </td>
              <td className="border border-gray-400 p-1 text-center align-top">{item.qty || 0}</td>
              <td className="border border-gray-400 p-1 text-center align-top">₹ {item.rate || 0}</td>
              <td className="border border-gray-400 p-1 text-center align-top font-medium">₹ {item.amount}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="flex justify-end">
        <div className="w-56">
          <div className="flex justify-between p-1 border-x border-t border-gray-400 font-bold">
            <span>Sub Total</span>
            <span>₹ {subtotal}</span>
          </div>
          <div className={`${excelLightBlue} border border-gray-400 font-bold`}>
            <div className="flex justify-between p-1 border-b border-gray-400">
              <span>GST</span>
              <span>{invoice.summary.taxRate}%</span>
            </div>
            <div className="flex justify-between p-1 border-b border-gray-400">
              <span>Total</span>
              <span>₹ {total}</span>
            </div>
            <div className="flex justify-between p-1">
              <span>Balance Due</span>
              <span>₹ {total}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-2 text-[9px]">
        <p className="text-gray-400 mb-1">Thank you for your business.</p>
        <p className="text-gray-500">
          Payment due upon receipt. GST applicable as per Indian tax rules.
        </p>
      </div>

    </div>
  );
};

export default ExcelTemplate;
